import Income from "./index";

const IncomeRoutes = [
  {
    component: Income,
    path: "/income",
    exact: true,
    type: "private",
  },
];

export default IncomeRoutes;
